(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/message/icon.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/message/icon.js'); "use strict";

(function (svs) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  class DialogMessageIcon extends svs.components.dialog.PubSub {
    constructor(icon) {
      super();
      this.log = new svs.core.log.Logger('DialogMessageIcon');
      this.createIconWrapper(icon);
    }

    createIconWrapper(icon) {
      this.el = document.createElement('div');
      this.el.className += 'dialog-icon ';
      this.el.innerHTML = svs.ui.icon.partials.icon({
        icon
      });
    }

  }

  svs.components.dialog.Icon = DialogMessageIcon;
})(svs);
 })(window);